<template>
    <div>
        <v-autocomplete v-model="booking.customer" :items="customers" :loading="isLoading" :search-input.sync="search" color="primary" hide-no-data item-text="display"
                        placeholder="Start typing to Search"
                        @change="emitChange"
                        return-object clearable
                        no-filter
        />
        <div v-if="booking.customer && booking.customer.name">
            <v-text-field v-model.trim="booking.customer.name" :rules="requiredRules" label="Name" required disabled/>
            <v-text-field v-model.trim="booking.customer.email" label="Email"/>
            <v-text-field v-model.trim="booking.customer.phone" label="Phone"/>
            <v-text-field v-model.trim="booking.customer.mobile" label="Mobile"/>
            <v-text-field v-model.trim="booking.customer.make" label="Make"/>
            <v-text-field v-model.trim="booking.customer.model" label="Model"/>
            <v-text-field v-model.trim="booking.customer.vrm" label="Registration Mark"/>
            <v-text-field v-model.trim="booking.customer.colour" label="Colour"/>
        </div>
    </div>
</template>

<script>
    import {EventBus} from '../../../../EventBus';
    import {CustomersHttp} from "../../../../http/customers";
    import {EstimatesHttp} from "../../../../http/estimates";
    export default {
        name: "RsCustomer",
        data() {
            return {
                search: '',
                customers: [],
                isLoading: false,
                requiredRules: [
                    v => !!v || 'This field is required'
                ],
            }
        },
        props: {
            booking: {}
        },
        watch: {
            async search (val) {
                // Need more characters to search
                if (val && val.length < 3) return;
                if (val) {
                    this.isLoading = true;
                    await CustomersHttp.findCustomers(val).then(result => {
                        const temp = result.data;
                        temp.map(t => {
                            t.display = `${t.name} - ${t.vrm}`;
                        });
                        this.customers = temp;
                    }).catch(err => {
                        EventBus.$emit('message', {message: err.message, type: 'error'});
                    }).finally(() => this.isLoading = false);
                }
            },
            customer() {
                this.customers = [];
            }
        },
        methods: {
            async emitChange() {
                // First check to see if there is an open estimate for this customer
                const estimate = await EstimatesHttp.searchByCustomerId(this.booking.customer._id);
                if (estimate) {
                    await this.$store.dispatch('estimates/setActiveEstimate', estimate);
                    const newBooking = {...estimate};
                    newBooking.dailyTotals = [];
                    delete newBooking._id;
                    await this.$store.dispatch('bookings/setActiveBooking', newBooking);
                } else {
                    EventBus.$emit('customer-selected', this.booking);
                }
            },
            getVal(item) {
                return `${item.name} - ${item.vrm}`
            }
        }
    }
</script>

<style scoped>

</style>
